import { Fragment, useState } from 'react';

import { AuthFlow } from '@playbooks/components/auth/auth-flow';
import { useSession } from '@playbooks/contexts';
import { Button } from '@playbooks/ui/components/button';

const AuthBtn = ({ variant = '', onClick, ...props }) => {
	const [open, setOpen] = useState(false);
	const session = useSession();

	// Methods
	const onAuth = () => {
		if (!session.isAuthenticated()) {
			return setOpen(true);
		}
		onClick();
	};

	const onRefresh = () => {
		setOpen(false);
	};

	// Render
	return (
		<Fragment>
			{variant === '' && <Button onClick={onAuth} {...props}></Button>}
			{variant === 'primary' && <Button onClick={onAuth} {...props}></Button>}
			{variant === 'accent' && <Button variant='secondary' onClick={onAuth} {...props}></Button>}
			{variant === 'border' && <Button variant='outline' onClick={onAuth} {...props}></Button>}
			{variant === 'text' && <Button variant='link' onClick={onAuth} {...props}></Button>}
			{variant === 'drop' && <Button onClick={onAuth} {...props} />}
			<AuthFlow open={open} setOpen={setOpen} onNext={onRefresh} />
		</Fragment>
	);
};

export { AuthBtn };
